export const COLORS_GLOBAL = {
  BTN_DISABLED: "#C7C7D6",
  BTN_DISABLED_BG: "#EEEEF6",
  MAIN_YELLOW: "#efa21e",
  MAIN_DARK: "#343745",
};



